/* eslint-disable max-len */
/* eslint-disable object-curly-newline */
import React from 'react';
import PropTypes from 'prop-types';
import BalanceBox from './BalanceBox';

function MemberBalanceRow({ member, policies, getMembers }) {
  const { firstName, lastName, email } = member.user;
  const balances = member.ptoBalances;

  return (
    <tr className="border-b border-rule hover:bg-surface-page transition" style={{ borderBottomStyle: 'solid' }}>
      <td style={{ padding: '12px 8px 12px 16px', verticalAlign: 'middle' }}>
        <span className="block font-medium text-ink-900" style={{ fontSize: 14, lineHeight: '20px' }}>{`${firstName} ${lastName}`.trim() || email}</span>
        {email ? <span className="block text-ink-500 truncate" style={{ fontSize: 11, lineHeight: '16px', marginTop: 2 }}>{email}</span> : null}
      </td>
      {policies.map((policy) => {
        const match = balances?.find((balance) => balance.policyId === policy.id);
        if (match) return <BalanceBox key={policy.id} match={match} getMembers={() => getMembers()} />;
        return <td key={policy.id} className="text-sm text-ink-500" style={{ padding: '12px 8px', verticalAlign: 'middle' }}>—</td>;
      })}
    </tr>
  );
}

MemberBalanceRow.propTypes = {
  member: PropTypes.shape({
    id: PropTypes.number.isRequired,
    ptoBalances: PropTypes.arrayOf(PropTypes.shape({})),
    user: PropTypes.shape({
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      email: PropTypes.string,
    }).isRequired,
  }).isRequired,
  policies: PropTypes.arrayOf(PropTypes.shape({})),
  getMembers: PropTypes.func.isRequired,
};

MemberBalanceRow.defaultProps = { policies: [] };

export default MemberBalanceRow;
